import React from 'react';
import { motion } from 'framer-motion';
import { Book, CheckCircle2 } from 'lucide-react';
export function SystemOverview() {
  const tomos = [{
    icon: '📘',
    title: 'Tomo 1 — La Máquina de Ingresos',
    desc: 'Modelo Sin Stock, el Sistema de las 48 Horas y tu primera venta hoy mismo.'
  }, {
    icon: '📗',
    title: 'Tomo 2 — El Menú Anti-Inflación',
    desc: 'Los 3 combos que cubren el 90% de la demanda + El Arte del Ensamblado.'
  }, {
    icon: '📙',
    title: 'Tomo 3 — Costos y Precios Blindados',
    desc: 'Fórmula Maestra, Ritual de los Lunes y Sistema de Señas (No perdés más).'
  }, {
    icon: '📕',
    title: 'Tomo 4 — Vender sin Poner un Peso',
    desc: 'Estrategia en IG + WhatsApp Business + Scripts de Cierre Express.'
  }, {
    icon: '📓',
    title: 'Tomo 5 — Fotos que Dan Hambre',
    desc: 'Setup de $0, luz natural, edición en 3 min y banco de contenido infinito.'
  }, {
    icon: '📔',
    title: 'Tomo 6 — Acelerador de Fechas Clave',
    desc: 'Preventa de 3 semanas, logística masiva para el Día de la Madre y Escala.'
  }];
  const includes = ['Plan de acción paso a paso', 'Checklists de control de calidad', 'Scripts de venta listos para copiar y pegar', 'Estrategias probadas en el mercado argentino', 'Sistemas de gestión de $0 inversión', 'Fórmulas de costos dinámicas'];
  return <section className="py-16 px-4 pt-[15px] pb-[15px]" data-id="element-256">
      <div className="max-w-6xl mx-auto" data-id="element-257">
        <div className="text-center mb-12" data-id="element-258">
          <div className="inline-flex items-center space-x-2 bg-brand/10 text-brand px-4 py-2 rounded-full mb-6 font-bold" data-id="element-259">
            <Book className="w-5 h-5" data-id="element-260" />
            <span data-id="element-261">EL SISTEMA</span>
          </div>
          <h2 className="text-3xl md:text-5xl font-black mb-4" data-id="element-262">
            🏆 ULTRAPACK™ DESAYUNOS RENTABLES
          </h2>
          <p className="text-xl text-gray-400" data-id="element-263">6 Tomos + 6 Bonos</p>
          <p className="text-brand font-bold mt-2" data-id="element-264">
            500+ páginas — Todo resuelto.
          </p>
        </div>

        <h3 className="text-2xl font-bold mb-6 text-center mt-[-30px]" data-id="element-265">
          📚 LOS 6 TOMOS COMPLETOS
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-12" data-id="element-266">
          {tomos.map((tomo, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-dark-card border border-dark-border rounded-2xl p-4 hover:border-brand/50 transition-colors" data-id="element-267">
              <div className="text-2xl mb-3" data-id="element-268">{tomo.icon}</div>
              <h4 className="text-lg font-bold mb-2" data-id="element-269">{tomo.title}</h4>
              <p className="text-gray-400 text-sm" data-id="element-270">{tomo.desc}</p>
            </motion.div>)}
        </div>

        <div className="bg-dark-card border border-dark-border rounded-2xl p-8 max-w-3xl mx-auto mt-[-25px]" data-id="element-271">
          <h4 className="text-xl font-bold mb-6 text-center" data-id="element-272">
            Cada tomo incluye:
          </h4>
          <div className="space-y-4" data-id="element-273">
            {includes.map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-center space-x-3" data-id="element-274">
                <CheckCircle2 className="w-6 h-6 text-brand flex-shrink-0" data-id="element-275" />
                <span className="text-gray-300 text-lg" data-id="element-276">{item}</span>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}